export default function getTableCellsTillBreak(cells) {
  var rowBroke = false;
  var willBroke = false;
  return cells.takeWhile(function (cell) {
    rowBroke = willBroke;
    willBroke = cell.getIn(['data', 'rowBreak']);
    return !rowBroke;
  });
}